import React from 'react'

import { t } from 'i18n'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useSignUp } from './common'

const useStyles = makeStyles((theme) => ({
  paragraph: {
    margin: theme.spacing(2, 0),
    lineHeight: 1.5
  },
  container: {
    textAlign: 'center'
  },
  link: {
    fontWeight: theme.palette.inputs.label.regular
  }
}))

export const ConfirmationForm: React.FC = () => {
  const classes = useStyles()

  const { signUp } = useSignUp()

  // const handleChangeEmail = (event: React.MouseEvent): void => {
  //   event.preventDefault()
  //   // TODO: render edit form
  // }

  return (
    <div className={classes.container}>
      <Typography component='h1' variant='h6'>
        {t('sign_up.confirmation_form.form_title')}
      </Typography>
      <Typography component='p' className={classes.paragraph}>
        {t('sign_up.confirmation_form.link_sent')}
        &nbsp;
        <b>{signUp.email}</b>
        <br />
        {t('sign_up.confirmation_form.instructions')}
      </Typography>
      <Typography component='p' className={classes.paragraph}></Typography>
      {/* <a href='#' onClick={handleChangeEmail} className={classes.link}>
        {t('sign_up.confirmation_form.change_email')}
      </a> */}
    </div>
  )
}
